import { ViewChild } from '@angular/core';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DxPopoverComponent } from 'devextreme-angular/ui/popover';
import { DialogService } from 'primeng/dynamicdialog';
import { ManagerApprovalModalComponent } from '../../manager-approval-modal/manager-approval-modal.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import { faP } from '@fortawesome/free-solid-svg-icons';
import { RegisterUserProperties } from '../RegisterProperties';
import { RegisterService } from '../register.service';
import { environment } from '../../../environments/environment';
declare var $;
@Component({
  selector: 'app-register-list',
  templateUrl: './register-list.component.html',
  styleUrls: ['./register-list.component.css']
})


/** register-list component*/
export class RegisterListComponent {
  @ViewChild(DxPopoverComponent, { static: false }) popOver: DxPopoverComponent;
  registerList: RegisterUserProperties[] = [];
  popoverTarget: any;
  popOverText: string;
  loader: boolean = false;
  collapsed = false;
  faPenToSquare = faPenToSquare;
  loginRoleName: string = '';
  operatingCountry = environment.operatingCountry;
  constructor(private confirmationService: ConfirmationService, private service: RegisterService, private messageService: MessageService, private router: Router, private dialogService: DialogService) {
    this.popoverTarget = "";
    this.popOverText = "hello";
  }
  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "white", "color": "#212529", "font-weight": "bold" });
    if (!this.collapsed) {
      this.collapsed = true;
      e.component.expandRow(["EnviroCare"]);
    }
  };
  ngOnInit() {
    this.loginRoleName  = localStorage.getItem("LoginUserRoleName");
    this.getDataAlllist();

  }
  onCellHoverChanged(e) {

    if (e.rowType === "data" && e.column.dataField === "agencyBranchList" && e.eventType === "mouseover") {

      this.popOverText = e.text;
      this.popoverTarget = e.cellElement;
      this.popOver.width = "auto";
      this.popOver.height = "auto";
      this.popOver.visible = true;
      this.popOver.position = "top";
      this.popOver.instance.show();

    }
    if (e.rowType === "data" && e.eventType === "mouseout") {
      this.popOver.instance.hide();
    }
  }

  getDataAlllist() {
    //userId = localStorage.getItem()
    this.service.RegisterGetAlls(localStorage.getItem("UserId")).subscribe((data) => {
      this.registerList = data;
      console.log(data);

    });
  }
  setLimit(row: any) {
    const ref = this.dialogService.open(ManagerApprovalModalComponent, {
      header:'Manager WorkFlow',
      width: '450px',
      data: {
        registerId: row.registerID,
        creditLimit: row.creditLimit,
        creditDays: row.creditDays,
      },
      styleClass: 'custom-manager-modal'
    });

    ref.onClose.subscribe(result => {
      if (result) {
        this.getDataAlllist();
      }
    });
  }

  createAgency(row: any) {
    var registerByIds = new RegisterUserProperties();
     console.log(row);
    const registerId = row.registerID;
    let isApprovedAgency: boolean = row.isApproved;
    this.service.RegisterGetById(registerId).subscribe((data) => {
      if (data != null) {
        console.log("data fetch " + data);
        if (isApprovedAgency) {

          localStorage.setItem("ResgisterBecomePartner", JSON.stringify(data));
          this.router.navigateByUrl("/agencyMaster");
        } else {
          this.messageService.add({ severity: 'error', summary: '', detail: 'Agency is not approved by manager!' });
        }

      } else {
        this.messageService.add({ severity: 'error', summary: '', detail: 'Unable to fetch data!' });
      }
    })
   // console.log("Create agency clicked for:", row);
    // your logic here...
  }
  downloadDocuments(registerId: number) {
    this.service.downloadUserFiles(registerId)
      .subscribe({
        next: (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;
          a.download = `UserFiles_${registerId}.zip`;
          a.click();

          window.URL.revokeObjectURL(url);
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: '', detail: 'Failed to downlaod documents' });
        }
      });
  }

  approveOrRejectAgent(rowData: any): void {
    const newStatus = !rowData.isApproved;

    const payload = {
      RegisterId: rowData.registerID,
      isApproved: newStatus
    };

    this.service.approveOrRejectAgent(payload).subscribe(
      (result: boolean) => {
        if (result) {
          rowData.isApproved = newStatus;

          if (newStatus) {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: "Agent Approved Successfully"
            });
          } else {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: "Agent Rejected Successfully"
            });
          }
        }
      },
      error => {
        console.error('Approve/Reject agent failed', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: "Something went Wrong! Please Try Again Later"
        });
      }
    );
  }


  onEdit(record: any) {
    console.log("Edit clicked for:", record);

    // Example: navigate to edit page
    // this.router.navigate(['/edit-register', record.registerID]);

    // Example: open a modal
    // this.selectedRecord = record;
    // this.showEditModal = true;

    // Call your existing edit handler if you have one
    // this.updateROE(record.roeid);
  }
}
